import React from "react";

export const LazyHomePage = React.lazy(() => import("pages/HomePage"));

export const LazyLoginPage = React.lazy(() => import("pages/LoginPage"));

export const LazyPatientManagementPage = React.lazy(
  () => import("pages/Patient/PatientManagementPage")
);

export const LazyPatientDashboard = React.lazy(
  () => import("pages/Patient/PatientDashboard")
);

export const LazyAddPatientPage = React.lazy(
  () => import("pages/Patient/AddPatientPage")
);

export const LazyPrescriptionsPage = React.lazy(
  () => import("pages/PrescriptionsPage")
);

export const LazyPrescriptionManagementPage = React.lazy(() =>
  import("pages/PrescriptionManagementPage").then((module) => ({
    default: module.PrescriptionManagementPage,
  }))
);

export const LazyPrescriptionDetailPage = React.lazy(() =>
  import("pages/PrescriptionDetailPage").then((module) => ({
    default: module.PrescriptionDetailPage,
  }))
);

export const LazyPrescriptionCreatePage = React.lazy(() =>
  import("pages/PrescriptionCreatePage").then((module) => ({
    default: module.PrescriptionCreatePage,
  }))
);

export const LazyPracticeManagementPage = React.lazy(
  () => import("pages/PracticeManagementPage")
);

export const LazyPracticeProfilePage = React.lazy(
  () => import("pages/PracticeProfilePage")
);

export const LazyPracticeDetailPage = React.lazy(
  () => import("pages/PracticeDetailPage")
);

export const LazyPracticeConfigurationPage = React.lazy(
  () => import("pages/PracticeConfigurationPage")
);

export const LazyAppointmentPage = React.lazy(
  () => import("pages/AppointmentPage")
);

export const LazyAppointmentSettingsPage = React.lazy(
  () => import("pages/AppointmentSettingsPage")
);

export const LazyTreatmentPlanPage = React.lazy(
  () => import("pages/TreatmentPlanPage")
);

export const LazyGeneratedProtocolResultPage = React.lazy(
  () => import("pages/GeneratedProtocolResultPage")
);

export const LazyActivityPage = React.lazy(() => import("pages/ActivityPage"));

export const LazySleepPage = React.lazy(() => import("pages/SleepPage"));

export const LazyHeartMetricsPage = React.lazy(
  () => import("pages/HeartMetricsPage")
);

export const LazyBodyMeasurementsPage = React.lazy(
  () => import("pages/BodyMeasurementsPage")
);

export const LazyWearablesPage = React.lazy(
  () => import("pages/WearablesPage")
);

export const LazyDailyWellBeingScorePage = React.lazy(
  () => import("pages/DailyWellBeingScorePage")
);

export const LazyNutritionAndHydrationPage = React.lazy(
  () => import("pages/NutritionAndHydrationPage")
);

export const LazyReproductiveHealthPage = React.lazy(
  () => import("pages/ReproductiveHealthPage")
);

export const LazyUserProfilePage = React.lazy(
  () => import("pages/UserProfilePage")
);

export const LazySettingsResetPasswordPage = React.lazy(
  () => import("pages/SettingsResetPasswordPage")
);

export const LazyRoleManagementPage = React.lazy(() =>
  import("pages/RoleManagementPage").then((module) => ({
    default: module.RoleManagementPage,
  }))
);

export const LazyPaymentManagementPage = React.lazy(
  () => import("pages/PaymentManagementPage")
);

export const LazyForgotPasswordPage = React.lazy(
  () => import("pages/ForgotPasswordPage")
);

export const LazyResetPasswordPage = React.lazy(
  () => import("pages/ResetPasswordPage")
);

export const LazySignUpPage = React.lazy(() => import("pages/SignUpPage"));

export const LazyAuthActionPage = React.lazy(
  () => import("pages/AuthActionPage")
);

export const LazyOnboardingPage = React.lazy(
  () => import("pages/OnboardingPage")
);

export const LazyInviteProviderPage = React.lazy(
  () => import("pages/InviteProviderPage")
);

export const LazyChatPage = React.lazy(() => import("pages/Chat/ChatPage"));

export const LazyLearningCertificationPage = React.lazy(
  () => import("pages/LearningCertificationPage")
);

export const LazyUnauthorizedPage = React.lazy(
  () => import("pages/UnauthorizedPage")
);

export const LazyAppRedirectPage = React.lazy(
  () => import("pages/AppRedirectPage")
);

export const LazyPaymentSuccessfulPage = React.lazy(
  () => import("pages/PaymentSuccessfulPage")
);
